import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../../auth/auth.service';
import { MultiBuyerRole } from '../services/multi-buyer/interfaces/multi-buyer-company.interface';

@Injectable({ providedIn: 'root' })
export class MasterMultiBuyerRedirectGuard implements CanActivate {
  constructor(
    private readonly _auth: AuthService,
    private readonly _router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this._auth.resolveAccessControlConfig().pipe(
      map((resolved) => {
        const enableTemplate = this._auth.buyerConfig?.enableTemplate ?? false;
        const isMaster = resolved.userRole === MultiBuyerRole.MasterMultiBuyer;
        const canAccess = resolved.capabilities.canAccessMasterTemplate;

        if (isMaster && enableTemplate && canAccess) {
          return this._router.parseUrl('/create-templates');
        }
        return true;
      })
    );
  }
}
